/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiTenantSessionDto } from './MultiTenantSessionDto';
import {
    MultiTenantSessionDtoFromJSON,
    MultiTenantSessionDtoFromJSONTyped,
    MultiTenantSessionDtoToJSON,
    MultiTenantSessionDtoToJSONTyped,
} from './MultiTenantSessionDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface SessionValidationResponse
 */
export interface SessionValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionValidationResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof SessionValidationResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof SessionValidationResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof SessionValidationResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {boolean}
     * @memberof SessionValidationResponse
     */
    valid?: boolean;
    /**
     * 
     * @type {MultiTenantSessionDto}
     * @memberof SessionValidationResponse
     */
    session?: MultiTenantSessionDto;
    /**
     * 
     * @type {string}
     * @memberof SessionValidationResponse
     */
    reason?: string;
}

/**
 * Check if a given object implements the SessionValidationResponse interface.
 */
export function instanceOfSessionValidationResponse(value: object): value is SessionValidationResponse {
    return true;
}

export function SessionValidationResponseFromJSON(json: any): SessionValidationResponse {
    return SessionValidationResponseFromJSONTyped(json, false);
}

export function SessionValidationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionValidationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'valid': json['valid'] == null ? undefined : json['valid'],
        'session': json['session'] == null ? undefined : MultiTenantSessionDtoFromJSON(json['session']),
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function SessionValidationResponseToJSON(json: any): SessionValidationResponse {
    return SessionValidationResponseToJSONTyped(json, false);
}

export function SessionValidationResponseToJSONTyped(value?: SessionValidationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'valid': value['valid'],
        'session': MultiTenantSessionDtoToJSON(value['session']),
        'reason': value['reason'],
    };
}

